import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isArray } from 'class-validator';
import { DataDirectoryService } from './data-directory.service';


@Component({
  selector: 'app-datadirectory',
  templateUrl: './datadirectory.component.html',
  styleUrls: ['./datadirectory.component.scss']
})
export class DatadirectoryComponent implements OnInit {

  molecule_Key: any = {};
  moleculeDetails: any = new Map();
  molecularDetailsKeys: any = [];
  email: any;

  constructor(private directoryservice: DataDirectoryService, private router: Router) {
    this.directoryservice.serchKey = '';
  }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.postDataDirectoryDetails()

  }

  /**
   * method to get all molecules
   */

  postDataDirectoryDetails() {
    let moleculeDataKey: any = {
      "key": "DiSpLaY",
      "user_email": this.email
    }

    this.molecule_Key = moleculeDataKey;
    this.directoryservice.postDirectoryData(this.molecule_Key).subscribe((resp: any) => {
      console.log('resp', resp.data)
      const dataArray = resp.data;
      const mapOfElement = new Map();
      for (let element of dataArray) {
        let ch = element["Brand Name/Proprietary Name"].charAt(0).toUpperCase();
        const tempArray = mapOfElement.get(ch);
        if (tempArray === undefined) {
          const elements = [];
          elements.push(element);
          mapOfElement.set(ch, element);
        } else {
          if (tempArray instanceof Array) {
            tempArray.push(element)
            mapOfElement.set(ch, tempArray);
          } else {
            const elements = [element, tempArray];
            mapOfElement.set(ch, elements);
          }
        }

      }
      this.moleculeDetails = mapOfElement;
    })
  }


  // to check is array condition
  isArray(element): boolean {
    return element instanceof Array;
  }

  // to get keys 
  getKeys(): string[] {
    this.molecularDetailsKeys = Array.from(this.moleculeDetails.keys());
    this.molecularDetailsKeys.sort(function (key1, key2) { return key1 > key2 ? 1 : -1 }); // Order by ascending property value
    return this.molecularDetailsKeys;
  }

  // to get values 
  getValue(detailsMap, key): any[] {
    let enlements = detailsMap.get(key);
    enlements.sort(function (key1, key2) {
      return key1["Brand Name/Proprietary Name"].toLowerCase() > key2["Brand Name/Proprietary Name"].toLowerCase() ? 1 : -1;
    });
    return enlements;
  }

  serchValue(data) {
    console.log('dt', data['Brand Name/Proprietary Name'])
    this.directoryservice.serchKey = data['Brand Name/Proprietary Name'];
    this.router.navigateByUrl('/home');
  }

}
